import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_SALES_CPE = '[CPE] GET SALES CPE'
export const SEND_UNINFORMED_SALES_TO_SUNAT = '[CPE] SEND UNINFORMED SALES TO SUNAT'
export const SEND_SALE_TO_SUNAT = '[CPE] SEND SALE TO SUNAT'

export function getSalesCPEAction(filters = { startDate: '', endDate: '', status: '', search: '', pageSize: 10 }) {
  const request = api.get(`/sales-cpe/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_SALES_CPE, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SALES_CPE, payload: { ...response.data.data } })
    }).catch((error) => {
      toast.error('Error inesperado. No se pudo obtener las boletas y facturas')
      console.log(GET_SALES_CPE, error)
    }).finally(() => {
      dispatch({ type: GET_SALES_CPE, payload: { loading: false } })
    })
  }
}

export function sendUninformedSalesToSunatAction() {
  const request = api.post(`/sales-cpe/send-uninformed-to-sunat`)
  return (dispatch) => {
    dispatch({ type: SEND_UNINFORMED_SALES_TO_SUNAT, payload: { sending: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      toast.success(response.data.message)
      dispatch({ type: SEND_UNINFORMED_SALES_TO_SUNAT, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo enviar las ventas a SUNAT")
      console.log(SEND_UNINFORMED_SALES_TO_SUNAT, error)
    }).finally(() => {
      dispatch({ type: SEND_UNINFORMED_SALES_TO_SUNAT, payload: { sending: false } })
    })
  }
}

export function sendSaleToSunatAction(saleId) {
  const request = api.post(`/sale-cpe/send-to-sunat/${saleId}`)
  return (dispatch) => {
    dispatch({ type: SEND_SALE_TO_SUNAT, payload: { sending_id: saleId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SEND_SALE_TO_SUNAT, payload: { sent_id: saleId, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo enviar la venta a SUNAT")
      console.log(SEND_SALE_TO_SUNAT, error)
    }).finally(() => {
      dispatch({ type: SEND_SALE_TO_SUNAT, payload: { sending_id: saleId } })
    })
  }
}

export function checkIfSaleWasSentToSunatAction(saleId, successCallback) {
  const request = api.get(`/sale-cpe/check-sent/${saleId}`)
  request.then((response) => {
    if (Number(response.data.status) !== 200) {
      toast.error(response.data.message)
      return
    }
    toast.success(response.data.message)
    if (successCallback) successCallback()
  }).catch((error) => {
    toast.error("Error inesperado, no se pudo enviar la venta a SUNAT")
    console.log(error)
  })
}
